/* eslint-disable camelcase */
import {
    getProxiedServiceUrl
} from 'gw-portals-url-js';
import {
    JsonRPCService
} from 'gw-portals-transport-js';
import {
    DocumentUploadService,
    DocumentDownloadService,
    VendorDocumentUploadService
} from 'gw-portals-document-js';
import VendorDocumentDownloadService from 'gw-portals-document-js/VendorDocumentDownloadService';

export default class ServiceRequestService {
    static getServiceRequestsForVendor(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestsForVendor', [], additionalHeaders);
    }

    static getServiceRequestDetails(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestDetails', [serviceRequestNumber], additionalHeaders);
    }

    // eslint-disable-next-line camelcase
    static getServiceRequestDetails_EXT(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestDetails_EXT', [serviceRequestNumber], additionalHeaders);
    }

    static getMessagesForSpecialist(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getMessagesForSpecialist', [], additionalHeaders);
    }

    static acceptWork(acceptWorkDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'acceptWork', [acceptWorkDTO], additionalHeaders);
    }

    static declineWork(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'declineWork', [serviceRequestAction], additionalHeaders);
    }

    // eslint-disable-next-line camelcase
    static declineToBid_EXT(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'declineToBid_EXT', [serviceRequestAction], additionalHeaders);
    }

    static cancelServiceRequest(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'cancelServiceRequest', [serviceRequestAction], additionalHeaders);
    }

    static cancelBid_EXT(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'cancelBid_EXT', [serviceRequestAction], additionalHeaders);
    }

    static completeWork(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'completeWork', [serviceRequestNumber], additionalHeaders);
    }

    static reportBlocked(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'reportBlocked', [serviceRequestAction], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('serviceRequestDocUpload'), file, documentMetadata, additionalHeaders);
    }

    static uploadDocumentForVendorInCM(file, documentMetadata, additionalHeaders = {}) {
        return VendorDocumentUploadService.send(getProxiedServiceUrl('vendorDocument'), file, documentMetadata, additionalHeaders);
    }

    // static uploadDocumentForVendorInCM(file, documentMetadata, additionalHeaders = {}) {
    //     return JsonRPCService.send(getProxiedServiceUrl('vendorDocument'), 'isCalling', [], additionalHeaders);
    // }

    static generateUploadToken(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequestDocs'), 'generateUploadToken', [], additionalHeaders);
    }

    static addOrReplaceQuote(publicID, quoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'addOrReplaceQuote', [publicID, quoteDTO], additionalHeaders);
    }

    static reportDelay(serviceRequestReportDelay, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'reportDelay', [serviceRequestReportDelay], additionalHeaders);
    }

    static addInvoice(serviceRequestNumber, invoice, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'addInvoice', [serviceRequestNumber, invoice], additionalHeaders);
    }

    static withdrawInvoice(withdrawInvoice, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'withdrawInvoice', [withdrawInvoice], additionalHeaders);
    }

    static resumeWork(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'resumeWork', [serviceRequestNumber], additionalHeaders);
    }

    static createMessage(serviceRequestNumber, message, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'createMessage', [serviceRequestNumber, message], additionalHeaders);
    }

    static downloadDocumentLink(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('serviceRequestDownloadDocument'), documentID, token);
    }

    static downloadVendorDocumentLink_EXT(documentID, token) {
        return VendorDocumentDownloadService.getDocumentLink(getProxiedServiceUrl('vendorDocument'), documentID, token);
    }

    static populateSariaBankNames(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'populateBankNames_EXT', [], additionalHeaders);
    }

    static getEFTRecords_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'showBankRecordsForVendorContact_EXT', [], additionalHeaders);
    }

    static addNewBankAccount_EXT(bankVM, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'saveNewBankData_EXT', [bankVM], additionalHeaders);
    }

    static populateSariaBranchCodeForBankName_EXT(selectedBankName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'populatebankcode_EXT', [selectedBankName], additionalHeaders);
    }

    static deleteBankAccount_EXT(linkId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'deleteBankAccount_EXT', [linkId], additionalHeaders);
    }

    static isServiceRequestAvailable(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'isServiceRequestPresent_EXT', [], additionalHeaders);
    }

    // eslint-disable-next-line camelcase
    static removeDocument_EXT(serviceRequestId, documentPublicID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequestDocs'), 'removeDocument', [serviceRequestId, documentPublicID], additionalHeaders);
    }

    static checkingValidationForAVS(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'isAVSValidationSatisfied', [], additionalHeaders);
    }

    static acceptWork_EXT(acceptWorkDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'acceptWork_EXT', [acceptWorkDTO], additionalHeaders);
    }

    static retrieveTargetId_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'retrieveTargetId_EXT', [], additionalHeaders);
    }

    static removeVendorDocument_EXT(contactId, documentPublicID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('vendorDocument'), 'removeVendorDocument', [contactId, documentPublicID], additionalHeaders);
    }

    static retrieveExistingPublicIds(contactId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('vendorDocument'), 'retrieveBankDocuments_EXT', [contactId], additionalHeaders);
    }


}